export { BtnIconActivity1 } from "./BtnIconActivity1";
